import { useContext } from 'react'
import { AppContext, AppContextType } from '../../AppContext'
import AudioEngineDevSettingsPage from './AudioEngineDevSettingsPage'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'

export default function AudioEngineDevSettingsPageController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    if (appState.appState.showAudioEngineDevSettingsPage) {
        return (
            <CrossPlatformDialog
                frameName="Dialog:AudioEngineDevSettingsPage"
                classNameNative="w-[600px]"
                onDefaultClose={() => {
                    appDispatch({ type: 'update_app_state', value: { showAudioEngineDevSettingsPage: false } })
                }}
            >
                <AudioEngineDevSettingsPage />
            </CrossPlatformDialog>
        )
    } else {
        return null
    }
}
